/**
 * Whether a payment adds money to the wallet (a top-up) rather than settling a purchase or
 * renewal order.
 *
 * Asked of `purpose`, which the server derives once (`PaymentPurpose`), and never of `orderId`
 * alone: since 2026-09-12 a wallet top-up raises its own `BalanceTopUp` order, so it carries an
 * `orderId` exactly like a purchase does. The `orderId` fallback is only for a payment fetched
 * before `purpose` existed, where having no order really did mean a deposit.
 *
 * Shared by every screen that needs this distinction — `PaymentStatus`, the global payment
 * notification listener and the per-payment socket hook — so the rule lives in one place.
 */
export function isTopUpPayment(payment: {
  purpose?: "TopUp" | "Order";
  orderId?: string;
}): boolean {
  return payment.purpose ? payment.purpose === "TopUp" : !payment.orderId;
}
